export default "__VITE_ASSET__BDoG5jdE__"